import register from '../../../../global/js/registry';
export default register(
	'm-professional-product-table-mobile',
	() => import(/* webpackMode: "lazy" */ './m-professional-product-table-mobile.controller'),
);
